module.exports = __webpack_public_path__ + "static/img/agree_pic.3d952ec1.png";